import { useSyncExternalStore } from "react";

/**
 * Whether the "3D Layers" toolbar layer is currently toggled on, shared via a
 * tiny external store. Published by FuelLoad3DLayer (its `active` toggle state)
 * and read by sibling layer factories that gate their own 3D output on it —
 * notably AssetsLayer, which only extrudes buildings to 3D while the 3D Layers
 * toggle is on. In-memory only (not persisted): it mirrors live toggle state,
 * and defaults off to match FuelLoad3DLayer's initial `active` value.
 */
const listeners = new Set<() => void>();
let current = false;

export const set3DLayerActive = (value: boolean): void => {
  if (current === value) return;
  current = value;
  listeners.forEach((listener) => listener());
};

export const use3DLayerActive = (): boolean =>
  useSyncExternalStore(
    (callback) => {
      listeners.add(callback);
      return () => listeners.delete(callback);
    },
    () => current
  );
